/* Stylesheet */

.provider_container {
  margin: 52px 0px 0px 0px;

  .info_message {
    margin: 0px 0px 52px 0px;
    text-align: center;
    font-size: 14px;
    color: var(--ion-color-text-primary);
  }
}
